import React from 'react';
import cn from 'classnames';

import Input from '..';
import classes from './inputPrefix.module.scss';
import { IInputPrefix } from './types';

const InputPrefix: React.FC<IInputPrefix> = ({
	className,
	value,
	onChange,
	placeholder,
	prefix = '',
	error,
}) => {
	const urlValue = `${prefix}${value}`;

	const handleChange = (inputValue: string): void => {
		let newValue = '';
		const hasUrlPrefix = inputValue.startsWith(prefix);
		if (hasUrlPrefix) {
			newValue = inputValue.replace(prefix, '');
		}
		onChange(newValue);
	};

	return (
		<Input
			className={cn(classes.inputPassword, className)}
			value={urlValue}
			onChange={handleChange}
			placeholder={placeholder}
			type="text"
			error={error}
		/>
	);
};

export default InputPrefix;
